<div>
  <app-vctp-up-to-filters *ngIf="years"
    [years]="years"
    [secondYear]="secondYear"
    [yearUsed]="yearUsed"
    (search)="searchData($event)">
  </app-vctp-up-to-filters>
  <mat-divider></mat-divider>
  <app-vctp-up-to-bar-chart
    [title]="text"
    [subtitle]="subtitle"
    [displayUnits]="displayUnits"
    [data]="data">
  </app-vctp-up-to-bar-chart>
</div>
